import React, { useContext } from 'react';
import { Redirect, Route, useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import { UserSessionContext } from '../../App';

const PrivateRoute = ({ children, userType, checkTypeOfUser, ...rest }) => {
  const location = useLocation();
  const { authData, setAuthData } = useContext(UserSessionContext);
  const localAccessToken = localStorage.getItem('accessToken');
  const userId = localStorage.getItem('userId');
  if (!authData.accessToken) {
    setAuthData({ accessToken: localAccessToken, userId });
  }

  if (authData?.accessToken) {
    //admin try to access admin pages
    if (rest.path.includes('admin') && userType == 'ADMIN') {
      return <Route {...rest}>{children}</Route>;
    }
    //normal user try to access admin pages
    if (rest.path.includes('admin') && userType !== 'ADMIN') {
      return <Redirect to={{ pathname: '/' }} />;
    }
    //user try to access normal pages
    if (!rest.path.includes('admin') && userType !== 'ADMIN') {
      return <Route {...rest}>{children}</Route>;
    } else {
      //the admin try to access normal pages
      if (!rest.path.includes('admin') && userType == 'ADMIN') {
        return <Redirect to={{ pathname: '/admin' }} />;
      }
    }
    //user try to access normal pages=
    if (rest.path.includes('users-delete') && userType !== 'ADMIN' && location.state?.from === 'fromUserDelete') {
      return <Route {...rest}>{children}</Route>;
    } else {
      //the admin try to access normal page
      if (rest.path.includes('users-delete') && userType !== 'ADMIN' && location.state?.from !== 'fromUserDelete') {
        return <Redirect to={{ pathname: '/users-delete/login' }} />;
      }
    }
  } else {
    if (rest.path.includes('users-delete') && userType !== 'ADMIN' && location.state?.from === 'fromUserDelete' && location.state?.data) return <Route {...rest}>{children}</Route>;
    if (rest.path.includes('users-delete') && userType !== 'ADMIN' && location.state?.from !== 'fromUserDelete' && !location.state?.data) return <Redirect to={{ pathname: '/users-delete/login' }} />;
    return <Redirect to={{ pathname: '/login' }} />;
  }
};
export default PrivateRoute;
